<template>
  <section>
    <div class="sonAccount">
      <div class="title">个人资料</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="ruleForm.nickname"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userreal">
          <el-input v-model="ruleForm.userreal"></el-input>
        </el-form-item>
        <el-form-item label="电话号码" prop="telephone">
          <el-input v-model="ruleForm.telephone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="生日" required>
          <!-- <el-col :span="11"> -->
          <el-form-item prop="birthday">
            <el-date-picker
              type="date"
              placeholder="生日"
            format="yyyy 年 MM 月 dd 日"
       value-format="yyyy-MM-dd"
              v-model="ruleForm.birthday"
              style="width: 100%;"
            ></el-date-picker>
            <!-- <el-date-picker
              v-model="ruleForm.birthday"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            ></el-date-picker> -->
          </el-form-item>
          <!-- </el-col> -->
          <!-- <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="date2">
              <el-time-picker placeholder="选择时间" v-model="ruleForm.date2" style="width: 100%;"></el-time-picker>
            </el-form-item>
          </el-col>-->
        </el-form-item>
        <!-- <el-form-item label="即时配送" prop="delivery">
          <el-switch v-model="ruleForm.delivery"></el-switch>
        </el-form-item>
        <el-form-item label="活动性质" prop="type">
          <el-checkbox-group v-model="ruleForm.type">
            <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
            <el-checkbox label="地推活动" name="type"></el-checkbox>
            <el-checkbox label="线下主题活动" name="type"></el-checkbox>
            <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>-->
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="ruleForm.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="头像">
          <el-upload
            class="avatar-uploader"
            :action="uploadimg"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img v-if="ruleForm.headimgurl" :src="ruleForm.headimgurl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="活动形式" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      uploadimg: sessionStorage.baseUrl + "app/file/upload",
      ruleForm: {
        userreal: "",
        nickname: "",
        birthday: "",
        telephone: "",
        headimgurl: "",
        sex: "1"
      },
      rules: {
        userreal: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        telephone: [
          { required: true, message: "请输入手机号码", trigger: "blur" }
        ],
        // headimgurl:[  { required: true, message: "请上传用户头像", trigger: "blur" },],
        nickname: [
          { required: true, message: "请输入昵称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        birthday: [
          { required: true, message: "请选择日期", trigger: "blur" },
        ],

        sex: [{ required: true, message: "请选择性别", trigger: "change" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      console.log("valid", this.ruleForm);
    // this.ruleForm.birthday=(this.ruleForm.birthday).format('YYYY-MM-DD');
      console.log("valid", this.ruleForm);
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let res = await this.$fetch("Member/profile", {
            body: {
              act: "modify",
              data: this.ruleForm
            }
          });
          if (res) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
            this.getmemberziliao();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取个人资料
    async getmemberziliao() {
      let memberzl = await this.$fetch("Member/profile", {
        body: {
          act: "view"
        }
      });
      memberzl.sex = memberzl.sex + "";
      // console.log("memberzl", jinruser);
      // sessionStorage.user
      let userinfo=JSON.parse(localStorage.jinruser);
      userinfo.headimgurl=memberzl.headimgurl;
      localStorage.jinruser=JSON.stringify(userinfo)
      sessionStorage.user=JSON.stringify(userinfo)
      this.ruleForm = Object.assign(memberzl, {});
    },
    handleAvatarSuccess(res, file) {
      console.log(file);
      this.ruleForm.headimgurl = file.response.msg;
      //   console.log("this.headimgurl", this.headimgurl);
    }
  },
  mounted() {
    this.getmemberziliao();
  }
};
</script>
<style lang='scss' scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ziliao.vue